import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const equipmentTypesAdapter = getAdapter();

const equipmentTypesSlice = createSlice({
  name: 'equipmentTypes',
  initialState: equipmentTypesAdapter.getInitialState(),
  reducers: {
    setEquipmentTypes: (state, { payload: { equipmentTypes } }) => {
      equipmentTypesAdapter.setAll(state, sortByPriority(equipmentTypes));
    },
  },
});

const selectors = equipmentTypesAdapter.getSelectors(({ equipmentTypes }) => equipmentTypes);

export const getEquipmentTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getEquipmentTypes = (state) => getEquipmentTypesIncludingDeleted(state)
  .filter(({ name, deleted }) => !deleted);

export const {
  setEquipmentTypes,
} = equipmentTypesSlice.actions;


  const sortByPriority = (et) =>{
    try {
      let tmp =[];
      let standards = et.filter(x=>x.name.toLowerCase().includes("standard")).sort((a,b)=>a.name.localeCompare(b.name));
      let notStandards = et.filter(x=>!x.name.toLowerCase().includes("standard")).sort((a,b)=>a.name.localeCompare(b.name));
      tmp.push(...standards);
      tmp.push(...notStandards);
      return tmp;
    } catch (error) {
      console.error(error);
      return et;
    }
    
  }
export default equipmentTypesSlice.reducer;
